import React from 'react'
import { firebaseApp } from 'src/services/firebase'
import { useLoader } from 'genjo-ui/core/LoaderProvider'
import { useSnackbar } from 'genjo-ui/core/SnackbarProvider'
import { useAuth } from 'src/components/AuthProvider'


export function useLogin() {
  const { register, logout } = useAuth()
  const loader = useLoader()
  const snackbar = useSnackbar()

  const login = React.useCallback(
    async ({ email = '', password = '' }) => {
      loader.open('Logging in...')

      try {
        const response = await firebaseApp
          .auth()
          .signInWithEmailAndPassword(email, password)
          return register(response.user)
      } catch (error) {

        console.log({ error })

        snackbar.addMessage({
          text: error?.message || error,
          type: 'error',
        })

      } finally {
        loader.close()
      }

      return logout(null)
    },
    [snackbar, loader, register, logout],
  )

  return login
}